export enum MultipleItemRequirementType {
	/// <summary>
	/// At minimum, the specified number of items are required, but more can be added.
	/// </summary>
	AtLeast,

	/// <summary>
	/// At maximum, the specified number of items are required, but fewer can be added.
	/// </summary>
	AtMost,

	/// <summary>
	/// Exactly the specified number of items are required.
	/// </summary>
	Exactly,

	/// <summary>
	/// All of the specified items are required.
	/// </summary>
	All
}
